
import { IBulkDelete } from "@/interfaces/iPageModel";
import { EventManagementAPI } from "@/services/api/EventManagement.service";
import { IEventManagement } from "@/interfaces/iEventManagement";
import { TranslationService } from "@/core/services/TranslationService";
import ActivityModal from "@/views/user/modal/ActivityModal.vue";
import { hasPermission } from "@/core/services/permission.service";
import {
  defineComponent,
  onMounted,
  ref,
  computed,
  shallowRef,
  nextTick,
} from "vue";
// import KTModalCard from "@/components/cards/Card.vue";
import { usePagination } from "@/helpers/pagination";
import KTCreateEventModal from "@/components/modals/wizards/CreateEventModal.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { FormatMethods } from "@/helpers/data-format";
import { useToast } from "vue-toastification";
import {
  eventManagementTableBulkDelete,
  eventManagementTableFilters,
  eventManagementTableHeaders,
  EVENTMANAGEMENT_TABS,
} from "./dataTableOptions";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import { DrawerComponent } from "@/assets/ts/components";
import VZSideDrawer from "@/components/content/VZSideDrawer.vue";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { Modal } from "bootstrap";
import moment from "moment";

export default defineComponent({
  name: "event-Management",
  components: {
    // KTModalCard,
    KTCreateEventModal,
    Datatable,
    VZDeleteModal,
    VZSideDrawer,
    ActivityModal,
  },
  setup() {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const addMessage = t("pages.lookup.lookupAddedMessage");
    const editMessage = t("pages.lookup.lookupUpdatedMessage");
    const tableData = ref<IEventManagement[]>([]);
    const localPreference = ref({});
    const singleEvent = ref<IEventManagement>({
      webId: 1,
      startDate: "",
      endDate: "",
      eventName: "",
      eventType: "",
      scheduleType: "null",
      eventSubType: "",
      eventTypeCodeText: "",
      eventGroup: "100",
      communicationType: "",
      schedule: "",
      subject: "",
      body: "",
      status: "ACTIVE",
      provider: "",
      templateName: "",
      bodyChange: false,
      eventRecipientModels: [
        {
          recipientType: "",
          recipient: "",
        },
      ],
      eventRecipients: [
        {
          recipient_type: "",
          recipient: "",
          user_id: "",
        },
      ],
    });
    const loading = ref(false);
    const { page, total, rowsPerPage } = usePagination();
    const defaultFilter = ref({ status: "ACTIVE" });
    const showDeleteDialog = ref<any>(false);
    const tableHeader = ref(eventManagementTableHeaders());
    const selectedForAction = ref<Partial<IEventManagement>>({});
    const bulkDelete = ref<IBulkDelete>(eventManagementTableBulkDelete());
    const tableFilter = ref(eventManagementTableFilters());
    const showSearch = true;
    const tabs = shallowRef<ITabConfig[]>(EVENTMANAGEMENT_TABS());
    const sideDrawerTitle = ref<string>("");
    const sideDrawerIcon = ref<string>("");
    const openDrawer = ref<boolean>(false);
    const isOpenModal = ref<boolean>(false);
    const subTypeItems = ref();
    const format = computed(() => {
      return FormatMethods;
    });
    const tableRowClick = (item) => {
      openDrawer.value = true;
      tabs.value = tabs.value.map((tab) => {
        return {
          ...tab,
          props: { ...tab.props, data: item, openDrawer: openDrawer },
        };
      });
      sideDrawerTitle.value = `${item.eventName}`;
      sideDrawerIcon.value = "las la-business-time";
      selectedForAction.value = item;
      DrawerComponent?.getInstance("vz__drawer")?.toggle();
    };

    const eventsList = ref<IEventManagement[]>([]);
    const getEventsList = async () => {
      try {
        const data =
          await EventManagementAPI.getInstance().getEventManagementList({
            page: 0,
            size: 1000,
            status: "ACTIVE",
            sort: "createdDate,desc",
          });
        eventsList.value = [...data.content];
      } catch (err) {
        console.log(err);
      }
    };

    onMounted(async () => {
      setCurrentPageBreadcrumbs(t("Events"), ["Home", "Events"]);
      getScheduleEventSubTypeData();
      var drawerElement = document.getElementById("vz__drawer");
      loading.value = true;
      // queryUpdate({
      //   ...defaultFilter.value,
      //   page: page.value - 1,
      //   size: rowsPerPage.value,
      // });
      drawerElement?.addEventListener("transitionend", function (event) {
        if (event?.propertyName === "transform") {
          const targetElement = event.target as HTMLElement;
          if (targetElement.className === "drawer drawer-end") {
            // refreshList();
            openDrawer.value = false;
          }
        }
      });
      await getEventsList();
    });
    const getScheduleEventSubTypeData = async () => {
      subTypeItems.value = [];
      subTypeItems.value =
        await EventManagementAPI.getInstance().getAllScheduleEventSubTypes();
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate({ ...localPreference.value });
    };
    let permissionModel = ref<any>({
      create: "VYZOR:SETTINGS:EVENTS:CREATE",
      delete: "VYZOR:SETTINGS:EVENTS:DELETE",
      update: "VYZOR:SETTINGS:EVENTS:UPDATE",
    });
    const editEvent = async (item: IEventManagement) => {
      isOpenModal.value = false;
      singleEvent.value.webId = item.webId;
      singleEvent.value.startDate = item.startDate;
      singleEvent.value.endDate = item.endDate;
      singleEvent.value.eventName = item.eventName;
      singleEvent.value.eventType = item.eventType;
      singleEvent.value.scheduleType = item.scheduleType;
      singleEvent.value.eventSubType = item.eventSubType;
      singleEvent.value.provider = item.provider.toString();
      singleEvent.value.eventTypeCodeText = item.eventTypeCodeText;
      singleEvent.value.eventGroup = item.eventGroup;
      singleEvent.value.communicationType = item.communicationType;
      singleEvent.value.schedule = item.schedule;
      singleEvent.value.subject = item.subject;
      singleEvent.value.body = item.body;
      singleEvent.value.status = item.status;
      singleEvent.value.eventRecipientModels = item.eventRecipientModels;
      singleEvent.value.eventRecipients = item.eventRecipients;
      //console.log(singleEvent.value);
      isOpenModal.value = true;
      await nextTick();
      const modal = new Modal(
        document.getElementById(`kt_modal_create_event`) as HTMLElement
      );
      modal.show();
    };
    const createEvent = async () => {
      // console.log("Event Emit");
      isOpenModal.value = false;
      singleEvent.value = {
        webId: 1,
        startDate: "",
        endDate: "",
        eventName: "",
        eventType: "",
        scheduleType: "null",
        eventSubType: "",
        eventTypeCodeText: "",
        eventGroup: "100",
        communicationType: "",
        schedule: "",
        subject: "",
        body: "",
        status: "ACTIVE",
        provider: "",
        bodyChange: false,
        templateName: "",
        eventRecipientModels: [
          {
            recipientType: "",
            recipient: "",
          },
        ],
      };
      isOpenModal.value = true;
      await nextTick();
      const modal = new Modal(
        document.getElementById(`kt_modal_create_event`) as HTMLElement
      );
      modal.show();
    };
    const queryUpdate = async (params?: any) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
            startDate: params?.startDate === null ? [] : params?.startDate,
          };
        }
        localPreference.value = { ...params };
        if (params && params.subType) {
          params.subType = subTypeItems.value
            .filter((item) => params.subType.includes(item.value.toString()))
            .map((item) => item.text);
        }
        const data =
          await EventManagementAPI.getInstance().getEventManagementList({
            ...params,
          });
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        loading.value = false;
      }
    };
    const deleteAlertMessage = (item: any) => {
      if (item.eventAttached) {
        return `${t("validation.eventAttached")} ${t(
          "validation.sureToDelete"
        )} ${item.eventName}?`;
      }

      return `${t("validation.sureToDelete")} ${item.eventName}?`;
    };
    const someOfSelectedEvents = t("bulkDelete.someOfSelectedEvents");
    const areYouSure = t("bulkDelete.areYouSureEvents");
    const bulkDeleteTextForEvents = ref<string | null>(null);
    const selectedItemsForDelete = (items: any) => {
      if (items.length) {
        const selectedEvents = tableData.value.filter((event) =>
          items.includes(event.webId)
        );
        const attachedEvents = selectedEvents.filter(
          (event: any) => event.eventAttached
        );
        const areEventsAttached = attachedEvents.length > 0;
        if (areEventsAttached) {
          bulkDeleteTextForEvents.value = `${someOfSelectedEvents} ${areYouSure}`;
        } else {
          bulkDeleteTextForEvents.value = null;
        }
      } else {
        bulkDeleteTextForEvents.value = null;
      }
    };
    return {
      moment,
      getIllustrationsPath,
      defaultFilter,
      page,
      loading,
      tableData,
      total,
      rowsPerPage,
      tableHeader,
      queryUpdate,
      showSearch,
      format,
      selectedForAction,
      refreshList,
      bulkDelete,
      tableFilter,
      t,
      editEvent,
      singleEvent,
      createEvent,
      permissionModel,
      sideDrawerTitle,
      sideDrawerIcon,
      openDrawer,
      tableRowClick,
      tabs,
      isOpenModal,
      showDeleteDialog,
      hasPermission,
      getScheduleEventSubTypeData,
      subTypeItems,
      eventsList,
      getEventsList,
      deleteAlertMessage,
      bulkDeleteTextForEvents,
      selectedItemsForDelete,
    };
  },
});
